export function buildMemberNavItems({ clubCode, managedActivities = [], hasVotingAccess = false }) {
  const base = [
    { label: 'Dashboard', labelKey: "portalPresentation.member_dashboard", to: `/${clubCode}/dashboard` },
    { label: 'Book Facilities', labelKey: "portalPresentation.member_book_facilities", to: `/${clubCode}/book-facilities` },
    { label: 'Activities', labelKey: "portalPresentation.member_activities", to: `/${clubCode}/activities` },
    { label: 'Academy', labelKey: "portalPresentation.member_academy", to: `/${clubCode}/academy` },
    { label: 'Events', labelKey: "membersHome.events", to: `/${clubCode}/events` },
    { label: 'Reciprocal Clubs', labelKey: "portalPresentation.member_reciprocal_clubs", to: `/${clubCode}/reciprocal-clubs` },
    { label: 'Accommodations', labelKey: "portalPresentation.member_accommodations", to: `/${clubCode}/accommodations` },
  ]

  if (managedActivities.length > 0) {
    base.splice(5, 0, { label: 'Manage', labelKey: "golf.course.manage", to: `/${clubCode}/manage` })
  }

  if (hasVotingAccess) {
    base.push({ label: 'Voting', labelKey: "portalPresentation.member_voting", to: `/${clubCode}/voting` })
  }

  return base
}

// Labels for routed pages outside the primary navigation. Keep header consumers
// on canonical catalogue keys rather than treating every secondary page as Home.
export const MEMBER_SECONDARY_ROUTE_LABELS = {
  profile: 'portalPresentation.member_profile',
  account: 'membersHome.account',
  dining: 'portalPresentation.member_dining',
  'lets-play': 'memberRemaining.m55',
  'contact-front-desk': 'portalPresentation.member_contact_front_desk',
  'payment-received': 'portalPresentation.member_payment_received',
  'payment-cancelled': 'facilityBooking.checkoutCancelled',
  'payment-declined': 'portalPresentation.member_payment_declined',
  services: 'portalPresentation.memberCommand.services',
  'developer-diagnostics': 'portalPresentation.memberCommand.diagnostics',
}
